import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const BlurBox = ({ loading, children }) => {
  return (
    <div className={loading ? 'blur-box-active' : 'blur-box-deactive'}>
      {children}
    </div>
  );
};

BlurBox.propTypes = {
  loading: PropTypes.bool.isRequired,
  children: PropTypes.node
};

export default BlurBox;



// WEBPACK FOOTER //
// ./src/Components/BlurBox/index.js